import { api } from "../client";

export const oauthApi = {
  requestInfo: (rid: string) =>
    api<{ error: boolean; client_name: string; scopes: string[] }>("oauth/request-info", { body: { rid } }),
  decide: (rid: string, approve: boolean) =>
    api<{ error: boolean; redirect: string }>("oauth/approve", { body: { rid, approve } }),
};
